import * as angular from "angular";
import {AUTH_EVENTS} from "./security/security-module";

export type ApiResult = {
    success: boolean,
    data: any,
    message: string
}

export class Fetch {

    constructor(
        private base: string,
        private $rootScope: angular.IRootScopeService
    ) {}

    async get(url: string): Promise<ApiResult> {
        let response = await fetch(this.base + url, {
            credentials: "same-origin"
        });
        return this.unwrap(response);
    }

    async post(url: string, data: object): Promise<ApiResult> {
        let response = await fetch(this.base + url,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                credentials: "same-origin",
                body: JSON.stringify(data)
            });
        return this.unwrap(response);
    }


    private async unwrap(response: Response): Promise<ApiResult> {
        let result: ApiResult = {
            success: response.ok,
            data: null,
            message: null
        };

        if (response.ok) {
            let json = await response.json();
            result.success = json.success ?? response.ok; // Legacy endpoints do not return data in success/data/message format
            result.data = json.data ?? json;
            result.message = json.message;
            return result;
        } else if (response.status === 401) {
            // Notified Angular that user is not logged in, should result in global action
            this.$rootScope.$broadcast(AUTH_EVENTS.AUTH_FAILED);
        }

        return result;
    }
}